import * as React from 'react';

const SvgChevronUpDownDescendingOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "m12 4.832 5.582 5.61L19 9.033 12 2 5 9l1.415 1.414L12 4.832Z", fill: "currentColor" }),
    React.createElement("path", { d: "M12 18.61 6.418 13 5 14.41l7 7.032 7-7-1.415-1.413L12 18.61Z", fill: "#D1D1E3" })));

export { SvgChevronUpDownDescendingOutline as default };
